import React from "react";
import { ConfigProvider } from "antd";
import type { ThemeConfig } from "antd";
import { useTranslation } from "react-i18next";
import { antdLocaleForLanguage } from "../../utils/i18n/antdLocale";

type Props = {
  children: React.ReactNode;
  theme?: ThemeConfig;
  form?: React.ComponentProps<typeof ConfigProvider>["form"];
};

const AntdLocaleProvider: React.FC<Props> = ({ children, theme, form }) => {
  const { i18n } = useTranslation();
  return (
    <ConfigProvider
      theme={theme}
      form={form}
      locale={antdLocaleForLanguage(i18n.resolvedLanguage || i18n.language)}
    >
      {children}
    </ConfigProvider>
  );
};

export default AntdLocaleProvider;
